import { render } from "./AvDosya_GelenGiden_List.vue?vue&type=template&id=16cc6558"
import script from "./AvDosya_GelenGiden_List.vue?vue&type=script&lang=js"
export * from "./AvDosya_GelenGiden_List.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ET Projeleri\\Erol Teknik Web Uygulamarı\\ETCore_\\etcore-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__